"use client";

import { useEffect } from "react";

const legacyCredentialPrefixes = [
  "tables:manage:",
  "tables:notify:",
  "tables:event-manage:",
];

export function BrowserCredentialCleanup() {
  useEffect(() => {
    for (const key of Object.keys(window.localStorage)) {
      if (legacyCredentialPrefixes.some((prefix) => key.startsWith(prefix))) {
        window.localStorage.removeItem(key);
      }
    }
  }, []);

  return null;
}
